










import {
    ref,
    defineComponent
} from '@nuxtjs/composition-api';
import { useApi } from '~/composables/useApi';
import {
  useUiNotification
} from '~/composables/useUiNotification';
import ContactForm from './ContactForm/ContactForm.vue';
import {
    ContactFormFields
} from './ContactForm/types';

export default defineComponent({
    name: 'ContactPage',
    components: {
        ContactForm
    },
    props: {
        tag: {
            type: String,
            default: 'div',
        },
        content: {
            type: String,
            default: '',
        },
    },
    setup(_, {
        emit
    }) {

        const { mutate } = useApi();
        const {
            send: sendNotification
        } = useUiNotification();
        const contactForm = ref < ContactFormFields > ({
            email: '',
            name: '',
            telephone: '',
            comment: '',
        });
        const isSubmitting = ref(false);
        const observer = ref(null);

        const onContactFormSubmit = async (form: ContactFormFields) => {
            contactForm.value = form;
            
            isSubmitting.value = true;

            const request = `
mutation SubmitContactForm($name: String!, $email: String!, $comment: String!, $telephone: String!) {
submitContactForm(input: { name: $name, email: $email, comment: $comment, telephone: $telephone }) {
success
message
}
}
`;

            const variables = {
                name: form.name,
                email: form.email,
                comment: form.comment,
                telephone: form.telephone,
            };

            const {
                data,
                errors
            } = await mutate(request, variables);

            if (errors) {
            console.log('GraphQL Errors:', errors); // Log GraphQL errors

                errors.forEach((error, i) => sendNotification({
                icon: 'error',
                id: Symbol(`contact_error-${i}`),
                message: error.message,
                persist: false,
                title: 'OTP Login error',
                type: 'danger',
                }));
            }else{
            
                sendNotification({
                    id: Symbol(`contact_success`),
                    message: 'Thank you for reaching out! Your message has been successfully sent. We will get back to you shortly.',
                    persist: false,
                    title: 'Success',
                    type: 'success',
                    icon: 'check',
                });

                contactForm.value = {
                    email: '',
                    name: '',
                    telephone: '',
                    comment: '',
                };

                // Reset the validation state
                if (observer.value) {
                    observer.value.reset();
                }
                isSubmitting.value = false;
            }
            
            
            
        };

        return {
            contactForm,
            onContactFormSubmit,
            isSubmitting,
        };
    },
});
